import { Version } from './constants';

export const trimInput = (input) => {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z-]/g, '')
    .replace(/-{2,}/g, '-');
};

export const setTitle = (value) => {
  document.title = value ? `${value} - dictionarychat.ai` : 'Dictionary Chat';
};

export const getVersion = () => {
  return `${Version.MAJOR}.${Version.MINOR}.${Version.PATCH}`;
};

// Helper function for conditional logging based on environment
export const debugLog = (...args) => {
  const currentEnv = process.env.REACT_APP_CHAT_API_ENV || 'production';
  if (currentEnv === 'beta') {
    console.log(...args);
  }
};

export const debugError = (...args) => {
  const currentEnv = process.env.REACT_APP_CHAT_API_ENV || 'production';
  if (currentEnv === 'beta') {
    console.error(...args);
  }
};
